<template>
  <div class="dvFooter">
    <div class="dvFooter-links valign-wrapper">
      <a href="javascript:void(0)" @click="gotoMain()"><img src="@/assets/svg/alisi-firststep-icon.svg"/></a>
      <a href="/terms-of-use">Terms of Use</a>
      <a href="/privacy-policy">Privacy Policy</a>
      <a href="/contact-us">Contact</a>
      <a :href="userGuideUrl" target="_blank">User Guide</a>
    </div> <!-- dvFooter-links -->
    <div class="dvFooter-ALISI valign-wrapper">
      <span>© 2022 All Rights Reserved.</span>
      <a href="javascript:void(0)" @click="gotoMain()"><img src="@/assets/svg/ali-logo.svg"/></a>
    </div> <!-- dvFooter-ALISI -->
  </div> <!-- dvFooter -->
</template>

<script>
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import M from 'materialize-css'
  // import { mapState } from 'vuex';

  export default {
    name: 'footer-view',
    data: () => ({
      currentUserRole: '',
      userGuideUrl: ''
    }),
    methods: {
      gotoMain () {
        if (this.$getConstRole('ROLE_SUB_ADMIN') == this.currentUserRole){
          this.$router.push({ name: 'admin_channels' })
        } else {
          this.$router.push({ name: 'dashboard' })
        }
      }
    },
    mounted() {
      if(this.$route.name == 'signin'){
        return
      }else{
        this.currentUserRole = this.$store.getters.getCurrentUserRole

        if (this.$getConstRole('ROLE_SUB_ADMIN') == this.currentUserRole){
          this.userGuideUrl = '/user-guides/FirstStep-AdminGuide.pdf'
        } else {
          this.userGuideUrl = '/user-guides/FirstStep-UserGuide.pdf'
        }
      }

    }
  }
</script>
